import React from 'react';
import autoBind from 'react-autobind';
import FormList from './FormList.jsx';
import _ from 'lodash';

import {userTypes, downloadId, formGroups, applicationGroup} from '../../constants/CongratulationsConstants';
import {UserTypes} from '../../constants/ApplicationConstants';
import {ProductIds} from '../../constants/ApplicationConstants';
import {formatString, addClickCallbackToLink, removeClickCallback} from '../../utils/Formatter';
import CongratulationsStore from '../../stores/CongratulationsStore';

export default class ShellAccount extends React.Component {
    constructor(props) {
        super(props);
        autoBind(this);
        this.state = this.getStateFromStore();
    }

    getStateFromStore(){
        return {
            CongratulationsPageDocumentSwitch:CongratulationsStore.getCongratulationsPageDocumentKillSwitch()
        }
    }

    _onChange() {
        this.setState(this.getStateFromStore());
    }

    applicationForm(){
        let message = '';
        if (this.props.productCode === ProductIds.INVESTMENT){
            if (this.props.isSingleAccount){
                {
                    this.state.CongratulationsPageDocumentSwitch.killSwitch
                      ? (message =
                          this.props.content[this.props.productCode]
                            .newShellAccountApplicationFormSingleInvestorCopy)
                      : (message =
                          this.props.content[this.props.productCode]
                            .shellAccountApplicationFormSingleInvestorCopy);
                } 
            }
            else{
                message = this.props.content[this.props.productCode].shellAccountApplicationFormMultipleInvestorCopy;   
            }
        }
        else {
            {
              this.state.CongratulationsPageDocumentSwitch.killSwitch
                ? (message =
                    this.props.content[this.props.productCode]
                      .newShellAccountApplicationFormCopy)
                : (message =
                    this.props.content[this.props.productCode]
                      .shellAccountApplicationFormCopy);
            }
          }
        if (message){
            return(<p dangerouslySetInnerHTML={{__html: message}}></p>);
        }
    }

    getStep1Message(){
        let step1 = '';
        if (this.props.productCode === ProductIds.INVESTMENT){
            if (this.props.isSingleAccount){
                step1 = formatString(this.props.content[this.props.productCode].shellAccountInstructionsSingleInvestorStep1, {investorName: this.props.data.investorName});
            }
            else{
                step1 = this.props.content[this.props.productCode].shellAccountInstructionsMultipleInvestorStep1;   
            }
            
        }
        else{
            step1 = formatString(this.props.content[this.props.productCode].shellAccountInstructionsStep1, {investorName: this.props.data.investorName});
        }

        if (step1){
            return step1;
        }
    }

    getStep3Message(){
        let message = '';
        if (this.props.userType === UserTypes.INVESTOR) {
            {
              this.state.CongratulationsPageDocumentSwitch.killSwitch
                ? (message = this.props.content.newShellAccountInstructionsFniStep3)
                : (message = this.props.content.shellAccountInstructionsFniStep3);
            }
          } else if (this.props.userType === UserTypes.ADVISER) {
            {
              this.state.CongratulationsPageDocumentSwitch.killSwitch
                ? (message = this.props.content.newShellAccountInstructionsFnaStep3)
                : (message = this.props.content.shellAccountInstructionsFnaStep3);
            }
          }
        //Public
        else{
            message = this.props.content.shellAccountInstructionsPublicStep3;
        }

        if (message){
            return message;
        }
        
    }

    instructionSteps(){
        let steps = [];
        steps.push(this.getStep1Message());
        steps.push(this.props.content.shellAccountInstructionsStep2);
        steps.push(this.getStep3Message());
        
        let message = <div className="shell-account__instructions">
            {steps.map(function(value, index){
                return <div key={`instructionSteps_${index}`} dangerouslySetInnerHTML={{__html: value}}></div>;
            })}
        </div>;

        return message;
    }

    accountHolding(){
        let message = formatString(this.props.content.shellAccountHoldingCopy, {date: this.props.data.holdingDate});
        return (<div className="shell-account__belowInstructions" dangerouslySetInnerHTML={{__html: message}}></div>);
    }

    accountSetup(){
        return (<p>{this.props.content.shellAccountSetupCopy}</p>);
    }

    formList(){
        let group, index, formList;
        formList = _.cloneDeep(this.props.data.applicationFormList.concat(this.props.data.formList));
        index = _.findIndex(formList, function(n) { return n.value === 'appForm'; });

        if (index > -1) {
            formList[index].value = 'appFormShell';
        }
        if (this.props.productCode !== ProductIds.INVESTMENT){
            group = [applicationGroup].concat(formGroups);
        }
        return <FormList formList={formList}
                        groups={group}
                        downloadFileCallBack={this.download}
                        content={this.props.content[this.props.productCode].formList} />
    }

    render() {
        if (!this.props.content[this.props.productCode]){
            return null;
        }
        return (
            <div className="container">
                {this.applicationForm()}
                {this.instructionSteps()}
                {this.accountHolding()}
                {this.accountSetup()}
                {this.formList()}
            </div>);
    }

    download(e){
        let id;
        if (this.props.downloadFileCallBack){
            id = e.target.id === 'appFormShell'? 'appForm' : e.target.id;
            this.props.downloadFileCallBack(id);
        }
    }

    componentDidMount(){
        CongratulationsStore.addChangeListener(this._onChange);
        addClickCallbackToLink(downloadId.checklist, this.download);
    }

    componentWillUnmount(){
        CongratulationsStore.removeChangeListener(this._onChange);
        removeClickCallback(downloadId.checklist, this.download);
    }
}

ShellAccount.propTypes = {
    data: React.PropTypes.object.isRequired,
    content: React.PropTypes.object.isRequired,
    userType: React.PropTypes.oneOf(userTypes),
    productCode: React.PropTypes.number.isRequired,
    isSingleAccount: React.PropTypes.bool.isRequired,
    downloadFileCallBack: React.PropTypes.func
};


// WEBPACK FOOTER //
// C:/GH/1106/advice.noa.origination/~/eslint-loader!./components/Congratulations/ShellAccount.jsx